import * as React from 'react';
import { useSelector } from 'react-redux';

import { Title } from '../../components/Title';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export function TitleContainer(): React.JSX.Element {
  const { newbuildingName, newbuildingPath } = useSelector(getNewbuildingInfo);

  return <Title newbuildingName={newbuildingName} newbuildingLink={newbuildingPath} />;
}
